<div class="card mt-3">
  <h4 class="card-header"><mat-icon>outbond</mat-icon>&nbsp;<strong><span i18n>Aplikácie</span></strong></h4>
  <div class="card-body">
    <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
      <div *ngFor="let a of data">
        <a title="{{a.description}}" (click)="openApplication(a)">
          <img src="./assets/images/{{a.icon}}.png"> {{a.name}}
        </a>
      </div>
  </div>
</div>
